import { gql } from '@apollo/client'

export const GET_ORGANISATION_ORGANISERS = gql`
  query GetOrganisationOrganisers($organisationName: String!) {
    getOrganisationOrganisers(organisationName: $organisationName) {
      organisers {
        userId
        email
        name
        profileImage
        jobTitle
        company
        companyTitle
        university
        permissions
        role
      }
      pendingInvites {
        inviteId
        organisationName
        email
        name
        role
        status
        createdAt
        expiresAt
      }
    }
  }
`

export const GET_ORGANISATION_ORGANISER_INVITE = gql`
  query GetOrganisationOrganiserInvite($inviteId: String!) {
    getOrganisationOrganiserInvite(inviteId: $inviteId) {
      inviteId
      organisationName
      email
      name
      role
      status
      createdAt
      expiresAt
    }
  }
`

export const INVITE_ORGANISATION_ORGANISER = gql`
  mutation InviteOrganisationOrganiser(
    $input: InviteOrganisationOrganiserInput!
  ) {
    inviteOrganisationOrganiser(input: $input) {
      success
      inviteId
      userId
      status
    }
  }
`

export const REMOVE_ORGANISATION_ORGANISER = gql`
  mutation RemoveOrganisationOrganiser(
    $input: RemoveOrganisationOrganiserInput!
  ) {
    removeOrganisationOrganiser(input: $input) {
      success
    }
  }
`

export const UPDATE_ORGANISATION_ORGANISER_ROLE = gql`
  mutation UpdateOrganisationOrganiserRole(
    $input: UpdateOrganisationOrganiserRoleInput!
  ) {
    updateOrganisationOrganiserRole(input: $input) {
      success
      role
      permissions
    }
  }
`

export const CANCEL_ORGANISATION_ORGANISER_INVITE = gql`
  mutation CancelOrganisationOrganiserInvite($inviteId: String!) {
    cancelOrganisationOrganiserInvite(inviteId: $inviteId) {
      success
    }
  }
`

export const ACCEPT_ORGANISATION_ORGANISER_INVITE = gql`
  mutation AcceptOrganisationOrganiserInvite($inviteId: String!) {
    acceptOrganisationOrganiserInvite(inviteId: $inviteId) {
      success
      inviteId
      userId
      status
    }
  }
`

export const DECLINE_ORGANISATION_ORGANISER_INVITE = gql`
  mutation DeclineOrganisationOrganiserInvite($inviteId: String!) {
    declineOrganisationOrganiserInvite(inviteId: $inviteId) {
      success
    }
  }
`
